import Vue from 'vue'
import Vuex from 'vuex'
import { stateMerge } from "vue-object-merge"
require('./vendor/jsonpath')

import config from './config'

Vue.use(Vuex)

/*global jsonpath*/
jsonpath.scope({parseInt: parseInt, parseFloat: parseFloat})

function default_report(){
  return {'ledgers_closed' : {},
          'account_rate'   : {},
          'fees'           : {},
          'new_accounts'   : {},
          'offers'         : {},
          'payments'       : {},
          'tx_rate'        : {},
          'txs'            : {}};
}

export const store = new Vuex.Store({
  state : {
           nav : {
                     width :      '',
         content_max_width :      '',
                 collapsed :   false,
             title_padding :  '50px',
             title_display : 'unset',
             content_cols  : 10
        },

    connectivity_timer : null,

     ledger_id : '',
        ledger : {ledger_index : ''},

         tx_id : '',
            tx : {},
        object : {},

           txs : [],
    tx_tallies : { payments : 0,
                     offers : 0,
                    escrows : 0,
                   paychans : 0,
               account_sets : 0,
                 trust_sets : 0 },

    filter_tx_types : false,

    enabled_txs : { payments : true,
                      offers : true,
                     escrows : true,
                    paychans : true,
                account_sets : true,
                  trust_sets : true },

   loading_txs : true,
    paused_txs : false,
     tx_filter : '',

       account : {
                     id : '',
                   page :  0,
                section : '',
           num_per_page :  50,
                   sort :  'balance_desc',
                 search : ''
       },

       report : {
         section : 'ledgers',

         period  : '',

         per_ledger : false,

         selected   : {period : null, timestamp : null, subperiod : null},

         reports : {},

         data : default_report(),

         subreport : default_report(),

         retrieved : ''
      },

    callbacks : {
      socket_open : [],
      socket_msg  : [],
         commands : {}
    },

    socket: {
      isConnected: false,
      message: '',
      reconnectError: false,
    }
  },

  mutations: {
    // FIXME: define properties in css, add / remove 'collapsed' class to dom

    toggle_nav(state, mq){
      var alt_nav = mq == 'sm' || mq == 'md';
      
      var cl_size = alt_nav ?   '0px' :              '30px';
      var ex_size = alt_nav ? '200px' :                  '';
      var      mw = alt_nav ?   ''    : 'calc(100% - 30px)';
      var    cols = alt_nav ?   12    :                  10;

      state.nav.collapsed         = !state.nav.collapsed;
      state.nav.width             = state.nav.collapsed ?    cl_size : ex_size;
      state.nav.content_max_width = state.nav.collapsed ?         mw :      '';
      state.nav.title_padding     = state.nav.collapsed ?      '5px' :  '50px';
      state.nav.title_display     = state.nav.collapsed ?     'none' : 'unset';
      state.nav.content_cols      = state.nav.collapsed ?        12  :    cols;
    },

    // XXX: remove update_nav when no longer needed (see css properties FIXME above)
    update_nav(state, mq){
      var alt_nav = mq == 'sm' || mq == 'md';

      var cl_size = alt_nav ?   '0px' :              '30px';
      var ex_size = alt_nav ? '200px' :                  '';
      var      mw = alt_nav ?   ''    : 'calc(100% - 30px)';
      var    cols = alt_nav ?   12    :                  10;

      state.nav.width             = state.nav.collapsed ?    cl_size : ex_size;
      state.nav.content_max_width = state.nav.collapsed ?         mw :      '';
      state.nav.title_padding     = state.nav.collapsed ?      '5px' :  '50px';
      state.nav.title_display     = state.nav.collapsed ?     'none' : 'unset';
      state.nav.content_cols      = state.nav.collapsed ?        12  :    cols;
    },


    collapse_nav(state, mq){
      var alt_nav = mq == 'sm' || mq == 'md';

      var size = alt_nav ? '0px' : '30px';
      var   mw = alt_nav ? ''    : 'calc(100% - 30px)';

      state.nav.collapsed         = true;
      state.nav.width             = size;
      state.nav.content_max_width = mw;
      state.nav.title_padding     =  '5px';
      state.nav.title_display     = 'none';
      state.nav.content_cols      = 12;
    },

    ///

    set_connectivity_timer(state, timer){
      state.connectivity_timer = timer;
    },

    ///

    toggle_paused_txs(state){
      state.paused_txs = !state.paused_txs;
    },

    update_tx_filter(state, filter){
      state.tx_filter = filter;

      if(!filter) return;

      // remove txs that don't match filter
      for(var i = state.txs.length-1; i >= 0 ; i--){
        if(jsonpath.query(state.txs[i], filter).length == 0){
          state.txs.splice(i, 1);
        }
      }
    },

    clear_txs(state){
      state.txs = [];
    },

    add_tx(state, tx){
      if(state.paused_txs) return;

      if(state.tx_filter)
        if(jsonpath.query(tx, state.tx_filter).length == 0)
          return;

      var category = config.tx_category_for_type(tx["transaction"]["TransactionType"]);
      if(!state.enabled_txs[category])
        return;

      state.loading_txs = false;

      // making message reactive slows down perf
      Object.freeze(tx);

      state.txs.unshift(tx);
      state.txs.splice(config.TX_HISTORY, state.txs.length - config.TX_HISTORY);

      state.tx_tallies[category] += 1;
    },

    toggle_tx_type(state, tx){
      // disabled all initially
      if(!state.filter_tx_types){
        state.filter_tx_types = true;
        Object.keys(state.enabled_txs).forEach(function(t){
          state.enabled_txs[t] = false;
        });
      }

      state.enabled_txs[tx] = !state.enabled_txs[tx];

      var all_disabled =
        Object.keys(state.enabled_txs).every(function(t){
           return !state.enabled_txs[t];
        });

      // when all are disabled, reset to original state
      if(all_disabled){
        state.filter_tx_types = false;
        Object.keys(state.enabled_txs).forEach(function(t){
          state.enabled_txs[t] = true;
        });
      }

      // TODO remove txs in violation of type filters
    },

    ///

    set_ledger(state, ledger) {
      state.ledger = ledger.ledger;
    },

    clear_ledger(state){
      Object.assign(state.ledger, {});
    },

    clear_tx(state){
      Object.assign(state.tx, {});
    },

    set_ledger_id(state, id) {
      state.ledger_id = id;
    },

    set_tx(state, tx){
      state.tx = tx;
    },

    set_tx_id(state, id){
      state.tx_id = id;
    },

    set_account_id(state, account_id) {
      state.account.id = account_id;
    },

    set_account_section(state, section) {
      state.account.section = section;
    },

    set_account_page(state, page) {
      state.account.page = page;
    },

    set_accounts_per_page(state, pp) {
      state.account.num_per_page = pp;
    },

    set_accounts_sort(state, sort) {
      state.account.sort = sort;
    },

    set_accounts_search(state, search) {
      state.account.search = search;
    },

    set_report_section(state, section) {
      state.report.section = section;
    },

    set_report_period(state, period){
      state.report.period = period;
    },

    set_report_per_ledger(state, val){
        state.report.per_ledger = val;
    },

    clear_report_data(state){
      state.report.data = default_report();
    },

    set_report_data(state, data){
      stateMerge(state.report.data, data);
    },

    clear_subreport_data(state){
      state.report.subreport = default_report();
    },

    set_subreport_data(state, data){
      stateMerge(state.report.subreport, data);
    },

    set_report_retrieved(state, timestamp){
      state.report.retrieved = timestamp;
    },

    set_reports(state, reports){
      stateMerge(state.report.reports, reports);
    },

    set_selected_report(state, report){
      // XXX: why is this reactive but stateMerge & Object.assign aren't !!!
      state.report.selected = report;
    },

    clear_selected_report(state){
      state.report.selected.period = null;
      state.report.selected.timestamp = null;
      state.report.selected.subperiod = null;
    },

    ///

    on_open_socket(state, cb) {
      if(state.socket.isConnected){
        cb();
        return;
      }

      state.callbacks.socket_open.push(cb);
    },

    on_command(state, {cmd, cb}){
      state.callbacks.commands[cmd.id] = cb;
    },

    on_socket_message(state, cb){
      state.callbacks.socket_msg.push(cb);
    },

    rm_socket_message_cb(state, cb){
      state.callbacks.socket_msg.splice(state.callbacks.socket_msg.indexOf(cb), 1);
    },

    SOCKET_ONOPEN (state) {
      state.socket.isConnected = true
      state.callbacks.socket_open.forEach(function(cb){
        cb();
      });
    },

    SOCKET_ONCLOSE (state) {
      state.socket.isConnected = false
    },

    SOCKET_ONERROR ()  {
    },

    SOCKET_ONMESSAGE (state, message)  {
      if(message.id && state.callbacks.commands[message.id]){
        state.callbacks.commands[message.id](message["result"]);
        delete state.callbacks.commands[message.id];
      }

      state.callbacks.socket_msg.forEach(function(cb){
        cb(message);
      });
    },

    SOCKET_RECONNECT() {
    },

    SOCKET_RECONNECT_ERROR(state) {
      state.socket.reconnectError = true;
    }
  }
});

///

store.helpers = {
  is_tx_enabled : function(t){
    return store.state.enabled_txs[t]
  },

  report_selected_period_name : function(){
    switch(store.state.report.selected.period){
      case '300'  : return "5min"
      case '3600' : return "hour";
      case '86400': return "day";
    }

    return store.state.report.selected.period;
  },

  report_period_name : function(){
    switch(store.state.report.period){
      case '300'  : return "5min"
      case '3600' : return "hour";
      case '86400': return "day";
    }

    return store.state.report.period;
  }
}
